import AxiosClient from "../AxiosClient";

export const getReceivableDailyCheck = (params = {}) => {
  const url = `/api/balance/receivableDailyCheck?mode=${params.mode}&date=${params.date}&keyWord=${params.keyWord}&negativeBalanceToday=${params.negativeBalanceToday}&filterByToday=${params.filterByToday}&paymentToday=${params.paymentToday}&balanceToday=${params.balanceToday}&page=${params.page}&size=${params.size}`;
  return AxiosClient.get(url);
};

export const getPayableDailyConfirmation = (params = {}) => {
  const url = `/api/balance/payableDailyConfirmation?mode=${params.mode}&date=${params.date}&keyWord=${params.keyWord}&division=${params.division}&invoiceNumber=${params.invoiceNumber}&fromDate=${params.fromDate}&endDate=${params.endDate}&partition=${params.partition}&payment=${params.payment}&balanceToday=${params.balanceToday}&negativeBalanceToday=${params.negativeBalanceToday}&page=${params.page}&size=${params.size}`;
  return AxiosClient.get(url);
};
